import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { User, UserRepository } from 'src-ironside/repositories/user.repository';
import { ScreenMediator } from 'src-ironside/services/screen.mediator';
import { ConfirmDialogData } from 'src/app/shared/components/dialogs/dialog-data';
import { AlertService } from 'src/app/shared/services/alert-service';
import { LoginService } from 'src/app/shared/services/login.service';
import { ProfileService } from 'src/app/shared/services/profile.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from 'src-ironside/services/common.service';

@Component({
    selector: 'app-my-account-ironside',
    templateUrl: 'my-account-ironside.component.html',
    styleUrls: ['./my-account-ironside.component.css'],
    providers: [UserRepository, MessageService],
})
export class MyAccountIronsideComponent {
    
    userForm = this.fb.group({
        nom: ['', Validators.required],
        prenom: ['', Validators.required],
        function: [''],
        email: [{ value: '', disabled: true }, Validators.required],
        tel: ['', Validators.required],
        mobile: ['', Validators.required],
        civility: ['', Validators.required],
    });

    civilitiesDataOption: any;
    currentUser?: User;

    passwordChangeForm: FormGroup;
    deleteUserForm:FormGroup
    validateNewPassword: string[] = [];
    lengthNewPassword: number = 0;

    visibleChangePassword: boolean = false;
    visibleDeleteUser: boolean = false;

    hideOld: boolean = true;
    hideNew: boolean = true;
    hideConfirm: boolean = true;
    hasError: any;
    loading:boolean = false;
    isRequestedDeletion:boolean = false;
    userDetail:any

    constructor(
        private fb: FormBuilder,
        private userRepository: UserRepository,
        private screenMediator: ScreenMediator,
        // private dialog: MatDialog
        private alertService: AlertService,
        private loginService: LoginService,
        private messageService: MessageService,
        private profileService: ProfileService,
        private router: Router,
        private translate: TranslateService,
        private _commonService:CommonService,
    ) {
        this.userRepository.getCurrentUser().subscribe({
            next: (user: User) => this.getUserDetailSuccess(user),
            error: (_err) => {
                // Temporarily disable
                // this.screenMediator.toHome();
            },
        });

        this._commonService.getCurrentUserStore().subscribe((res)=>{
            this.isRequestedDeletion = res?.isRequestedDeletion;
            this.userDetail = res;
            if (this.isRequestedDeletion &&  this.deleteUserForm) {
                this.deleteUserForm?.get('reason')?.clearValidators();
                this.deleteUserForm?.get('reason')?.updateValueAndValidity();
            }
        })
        this.getCivilityOption();

        this.passwordChangeForm = this.fb.group(
            {
                oldPassword: ['', Validators.required],
                newPassword: ['', Validators.required],
                confirmedNewPassword: ['', Validators.required],
            },
            { validator: this.matchPassword }
        );

        this.deleteUserForm = this.fb.group({
            password: ['', Validators.required],
            reason: ['', this.isRequestedDeletion ? [] : Validators.required],
        });

        this.passwordChangeForm.get('newPassword')?.valueChanges.subscribe((el) => {
            if (!el) {
                this.validateNewPassword = [];
                this.lengthNewPassword = 0;
                return;
            }

            // Check if length is at least 8 characters
            if (el.length >= 8) {
                if (!this.validateNewPassword.includes('minLength')) {
                    this.validateNewPassword.push('minLength');
                }
            } else {
                this.validateNewPassword = this.validateNewPassword.filter(
                    (flag) => flag !== 'minLength'
                );
            }

            // Check if it contains at least one digit
            if (/\d/.test(el)) {
                if (!this.validateNewPassword.includes('digit')) {
                    this.validateNewPassword.push('digit');
                }
            } else {
                this.validateNewPassword = this.validateNewPassword.filter(
                    (flag) => flag !== 'digit'
                );
            }

            // Check if it contains at least one special character
            if (/[!@#$%^&*(),.?":{}|<>]/.test(el)) {
                if (!this.validateNewPassword.includes('specialChar')) {
                    this.validateNewPassword.push('specialChar');
                }
            } else {
                this.validateNewPassword = this.validateNewPassword.filter(
                    (flag) => flag !== 'specialChar'
                );
            }
            this.lengthNewPassword = el?.length;
        });
    }

    matchPassword(formGroup: FormGroup) {
        const newPassword = formGroup.get('newPassword')?.value;
        const confirmedNewPassword = formGroup.get('confirmedNewPassword')?.value;

        return newPassword === confirmedNewPassword ? null : { passwordMismatch: true };
    }

    changePassword() {
        // this.dialog.open(ChangePasswordComponent);

        let dialog: ConfirmDialogData = {
            title: 'Modification de mot de passe',
            message: 'Êtes-vous sûr de demander le changement de mot de passe',
            cancelText: `Non`,
            confirmText: `Oui`,
        };
        this.alertService.confirmDialog(dialog).subscribe((isOK) => {
            if (isOK && this.currentUser?.email) {
                this.loginService
                    .sendRecoveryLink(this.currentUser.email)
                    .subscribe((resp: any) => {
                        this.messageService.add({
                            severity: 'info',
                            summary: 'Info',
                            detail: resp.responseMessage,
                        });
                    });
            }
        });
    }

    save() {
        if (!this.userForm.valid || !this.currentUser) {
            return;
        }

        this.currentUser.firstName = this.userForm.get('prenom')?.value || '';
        this.currentUser.lastName = this.userForm.get('nom')?.value || '';
        this.currentUser.email = this.userForm.get('email')?.value || '';
        this.currentUser.phone = this.userForm.get('tel')?.value || '';
        this.currentUser.mobile = this.userForm.get('mobile')?.value || '';
        this.currentUser.job = this.userForm.get('function')?.value || '';
        this.currentUser.civility = this.userForm.get('civility')?.value || '';

        this.userRepository.save(this.currentUser).subscribe((user: User) => {
            this.messageService.add({
                severity: 'success',
                summary: 'Succès',
                detail: 'Vos modifications sont enregistrées',
            });
            this.getUserDetailSuccess(user);
        });
    }

    getUserDetailSuccess(user: User) {
        this.currentUser = user;
        this.userForm.patchValue({
            nom: user.lastName,
            prenom: user.firstName,
            email: user.email,
            tel: user.phone,
            function: user.job,
            mobile: user?.mobile,
            civility: user?.civility?.parameterId,
        });
    }

    getCivilityOption() {
        this.profileService.getCivilities('CIVILITY').subscribe({
            next: (res: any) => {
                const result = res?.response.map((el: any) => ({
                    labels: el.mapLocalLibelle,
                    parameterId: el?.id,
                    value: el?.valeur,
                }));
                this.civilitiesDataOption = result;
            },
        });
    }

   
    onChangeSubmitPassword() {
        this.loading = true;
        const form = this.passwordChangeForm.value;
        this.loginService
            .changePasswordUser(form.oldPassword, form.newPassword, form.confirmedNewPassword)
            .subscribe({
                next: () => {
                    this.loading = false;
                    this.passwordChangeForm.reset();
                    this.visibleChangePassword = false;
                    this.messageService.add({
                        severity: 'success',
                        detail:  this.translate.instant('IRONSIDE.my-account.PASSWORD_UPDATED_SUCCESS'),
                        life: 5000,
                    });
                    setTimeout(() => {
                        this.router.navigate(['/logout']);
                    }, 5000);

                },
                error: (err) => {
                    this.loading = false;
                    
                    this.messageService.add({
                        severity: 'warn',
                        detail:  err?.error?.message ? err?.error?.message : this.translate.instant('common.an-error-occurred'),
                    });
                },
        
            });
    }

    onCloseChangePasswordForm() {
        this.passwordChangeForm.reset();
        this.deleteUserForm.reset();
        this.visibleChangePassword = false;
        this.visibleDeleteUser = false;
    }

    onDeleteUser(){
        const result = this.deleteUserForm.value

        const observerble = this.isRequestedDeletion ? this.loginService?.cancelDeleteUser(result?.password):this.loginService.deleteUser(result.reason, result.password)
        this.loading = true;
        observerble.subscribe({
            next:(res)=>{
                this.loading = false;
                this.messageService.add({
                    severity: 'success',
                    detail:  this.translate.instant(this.isRequestedDeletion ? 'IRONSIDE.my-account.CANCEL_ACCOUNT_DELETION_SUCCESS':'IRONSIDE.my-account.DELETE_ACCOUNT_SUCCESS'),
                });
                this.onCloseChangePasswordForm()
                
                if (this._commonService) {
                    this._commonService.setCurrentUserStore({...this.userDetail, isRequestedDeletion: this.isRequestedDeletion ? false : true});
                }
            },
            error:(err)=>{
                this.loading = false;
                this.messageService.add({
                    severity: 'warn',
                    detail:  err?.error?.message ? err?.error?.message : this.translate.instant('common.an-error-occurred'),
                });
                
            }
        })
    }
}
